import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { CallApi } from "../../API/CallApi/CallApi";
import {
  CircularProgress,
  Drawer,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import "./TvScreenSlider.scss";
import notfound from "../../assets/noFoundP.png";
import nodatagif from "../../assets/nodata.gif";
import somthingworng from "../../assets/somthingwrong.gif";
import { useNavigate } from "react-router-dom";
import { useDeviceStatus } from "../../DeviceStatusContext";
import sample1 from '../../assets/1 (1)_cropped_processed_by_imagy.jpg'

const TvScreenSlider = () => {
  const swiperRef = useRef(null);
  const videoRefs = useRef([]);
  const drawerBtnRefs = useRef([]);
  const yesRef = useRef(null);
  const noRef = useRef(null);
  const reloadBtnRef = useRef(null);
  const errorReloadBtnRef = useRef(null);
  const errorLoginBtnRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [tvContentData, setTvContentData] = useState([]);
  const [MainUrl, setMainUrl] = useState([]);
  const [invalidToken, setInvalidToken] = useState(false);
  const [noDataFound, setNoDataFound] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const [dialogFocus, setDialogFocus] = useState("yes");
  const [confirmType, setConfirmType] = useState(null);
  const [errorFocusedIndex, setErrorFocusedIndex] = useState(0);
  const { deviceStatus } = useDeviceStatus();
  const navigate = useNavigate();
  const dialogOpenedOnceRef = useRef(false);

  const getSliderData = async () => {
    setIsLoading(true);
    const body = {
      con: '{"mode":"TvSetContent"}',
      p: '{"AppId":"4"}',
      f: "(TvSetContent)",
    };
    const response = await CallApi(body);
    if (response?.rd[0]?.stat == 0) {
      setInvalidToken(true);
    } else if (response?.rd?.length == 0) {
      setInvalidToken(false);
      setNoDataFound(true);
    } else {
      setTvContentData(
        [...response.rd].sort((a, b) => a.DisplayOrder - b.DisplayOrder)
      );
      setMainUrl(response?.rd1 || []);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (deviceStatus?.type === "REFRESH_SLIDER") {
      console.log("[TV] REFRESH_SLIDER received");
      setNoDataFound(false);
      setInvalidToken(false);
      getSliderData();
    }
  }, [deviceStatus?.timestamp]);

  useEffect(() => {
    getSliderData();
  }, []);

  useEffect(() => {
    if (noDataFound && reloadBtnRef.current) {
      setTimeout(() => reloadBtnRef.current?.focus(), 100);
    }
  }, [noDataFound]);

  useEffect(() => {
    if (invalidToken && errorReloadBtnRef.current) {
      setTimeout(() => errorReloadBtnRef.current?.focus(), 100);
    }
  }, [invalidToken]);

  useEffect(() => {
    if (confirmType && !dialogOpenedOnceRef.current) {
      dialogOpenedOnceRef.current = true;
      setDialogFocus("yes");
      setTimeout(() => yesRef.current?.focus(), 100);
    }
    if (!confirmType) {
      dialogOpenedOnceRef.current = false;
    }
  }, [confirmType]);

  useEffect(() => {
    if (!tvContentData.length) return;
    const current = tvContentData[currentIndex];
    if (!current || !swiperRef.current) return;

    let timer;
    const isVideo = current.FileType?.includes("video");
    const goNext = () => swiperRef.current.slideNext();

    if (!isVideo) {
      timer = setTimeout(goNext, current.Duration * 1000);
    } else {
      const video = videoRefs.current[currentIndex];
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => { });
        video.onended = goNext;
        video.onerror = goNext;
      }
    }

    return () => clearTimeout(timer);
  }, [currentIndex, tvContentData]);

  useEffect(() => {
    const handleKey = (e) => {
      if (invalidToken && !confirmType) {
        if (e.key === "ArrowRight") {
          e.preventDefault();
          setErrorFocusedIndex(1);
          errorLoginBtnRef.current?.focus();
          return;
        }
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          setErrorFocusedIndex(0);
          errorReloadBtnRef.current?.focus();
          return;
        }
        if (e.key === "Enter") {
          e.preventDefault();
          if (errorFocusedIndex === 0) {
            window.location.reload();
          } else {
            navigate("/logout", { replace: true });
          }
          return;
        }
        return;
      }

      if (noDataFound && !confirmType) {
        if (e.key === "Enter") {
          e.preventDefault();
          window.location.reload();
        }
        return;
      }

      if (confirmType) {
        if (e.key === "ArrowRight") {
          e.preventDefault();
          setDialogFocus("no");
          setTimeout(() => noRef.current?.focus(), 0);
          return;
        }
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          setDialogFocus("yes");
          setTimeout(() => yesRef.current?.focus(), 0);
          return;
        }
        if (e.key === "Enter") {
          e.preventDefault();
          handleConfirmAction(dialogFocus);
          return;
        }
        return;
      }

      if (
        e.key === "ArrowRight" &&
        !drawerOpen &&
        !confirmType &&
        !invalidToken &&
        !noDataFound
      ) {
        setDrawerOpen(true);
        setFocusedIndex(0);
        setTimeout(() => drawerBtnRefs.current[0]?.focus(), 100);
        return;
      }

      if (e.key === "ArrowLeft" && drawerOpen && !confirmType) {
        setDrawerOpen(false);
        return;
      }

      if (drawerOpen && !confirmType) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          const newIndex = Math.min(focusedIndex + 1, 1);
          setFocusedIndex(newIndex);
          setTimeout(() => drawerBtnRefs.current[newIndex]?.focus(), 0);
        }
        if (e.key === "ArrowUp") {
          e.preventDefault();
          const newIndex = Math.max(focusedIndex - 1, 0);
          setFocusedIndex(newIndex);
          setTimeout(() => drawerBtnRefs.current[newIndex]?.focus(), 0);
        }
        if (e.key === "Enter") {
          e.preventDefault();
          setConfirmType(focusedIndex === 0 ? "delete" : "logout");
          setDialogFocus("yes");
          setTimeout(() => yesRef.current?.focus(), 100);
        }
        return;
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [
    drawerOpen,
    focusedIndex,
    confirmType,
    invalidToken,
    noDataFound,
    errorFocusedIndex,
    dialogFocus,
    navigate,
  ]);

  const handleConfirmAction = (action) => {
    if (action === "no") {
      closeDialog();
      setTimeout(() => {
        drawerBtnRefs.current[focusedIndex]?.focus();
      }, 100);
      return;
    }

    if (confirmType === "logout") {
      closeDialog();
      navigate("/logout", { replace: true });
      return;
    }

    if (confirmType === "delete") {
      closeDialog();
      window.location.reload();
      window.history.pushState({}, "", "/account-delete");
      return;
    }
  };

  const closeDialog = () => {
    setConfirmType(null);
    setDialogFocus("yes");
  };

  const handleSlideChange = (swiper) => {
    setCurrentIndex(swiper.realIndex);
  };

  return (
    <div className="screen_main_div">
      {isLoading && (
        // <div className="loader-overlay">
        //   <CircularProgress />
        // </div>
        <div className="tv-loading-vertical">

          <span className="loading-text">
            {"Loading...".split("").map((char, index) => (
              <span key={index} style={{ "--i": index }}>
                {char}
              </span>
            ))}
          </span>
        </div>
      )}

      {!isLoading && !invalidToken && noDataFound && (
        <div className="nodata_main_div">
          <img src={nodatagif} style={{ width: "400px" }} />
          <p>Please Select Content....</p>
          <button
            ref={reloadBtnRef}
            onClick={() => window.location.reload()}
            className="Button_Nodata"
          >
            Reload
          </button>
        </div>
      )}

      {!isLoading && !noDataFound && invalidToken && (
        <div className="inavlid_token_main">
          <img src={somthingworng} style={{ width: "700px" }} />
          <div style={{ marginTop: "10px" }}>
            <button
              ref={errorReloadBtnRef}
              onClick={() => window.location.reload()}
              className={`Button_Invalid ${errorFocusedIndex === 0 ? "focused" : ""
                }`}
            >
              Reload
            </button>
            <button
              ref={errorLoginBtnRef}
              onClick={() => navigate("/logout", { replace: true })}
              className={`Button_Invalid ${errorFocusedIndex === 1 ? "focused" : ""
                }`}
            >
              Try Another Login
            </button>
          </div>
        </div>
      )}

      {!isLoading && !invalidToken && !noDataFound && (
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          onSlideChange={handleSlideChange}
          slidesPerView={1}
          allowTouchMove={false}
          loop={true}
        >
          {tvContentData?.map((item, idx) => {
            const fullPath = `${MainUrl[0]?.FilePath}${item.FileName}`;
            const isVideo = item.FileType?.includes("video");

            return (
              <SwiperSlide key={idx}>
                {isVideo ? (
                  <video
                    ref={(el) => (videoRefs.current[idx] = el)}
                    src={fullPath}
                    muted
                    playsInline
                    preload="auto"
                    style={{
                      width: "100%",
                      height: "100vh",
                    }}
                  />
                ) : (
                  <img
                    src={fullPath}
                    alt={item.FileName}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = notfound;
                    }}
                    style={{
                      width: "100%",
                      height: "100vh",
                    }}
                  />
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}

      <Drawer anchor="left" open={drawerOpen}>
        <div
          style={{
            width: 300,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {["Delete My Account", "Logout"].map((txt, i) => (
            <button
              key={i}
              ref={(el) => (drawerBtnRefs.current[i] = el)}
              className={`Button_Location ${focusedIndex === i ? "focused" : ""
                }`}
            >
              {txt}
            </button>
          ))}
        </div>
      </Drawer>

      <Dialog open={!!confirmType} onClose={closeDialog}>
        <DialogTitle>Are you sure you want to {confirmType}?</DialogTitle>
        <DialogActions>
          <button
            ref={yesRef}
            className={`Button_Confi ${dialogFocus === "yes" ? "focused" : ""}`}
            onClick={() => handleConfirmAction("yes")}
          >
            Yes
          </button>
          <button
            ref={noRef}
            className={`Button_Confi ${dialogFocus === "no" ? "focused" : ""}`}
            onClick={() => handleConfirmAction("no")}
          >
            No
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TvScreenSlider;